import script from "./ProsemirrorEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProsemirrorEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ProsemirrorEditor.vue?vue&type=style&index=0&id=3608adca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3608adca"]])

export default __exports__